/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_U0 as U0,
} from "../../runtime/index.jsx";
export function Componente_c3_99_51(e) {
  return (
    <span
      key={e}
      className={`rounded-full border border-(--warning-border) bg-(--warning-bg) px-2 py-0.5 text-[11px] text-(--text-h)`}
      children={U0[e] ?? e}
    />
  );
}
